/** URL segment of Silia Learning under the account (`/accounts/:accountId/learning`). */
export const LEARNING_ROUTE_SEGMENT = 'learning';

/** Child segments. A stage lives at `learning/<stageId>`; these two are fixed pages. */
export const NEWS_SEGMENT = 'novedades';
export const MCP_SEGMENT = 'mcp';

/**
 * The releases, as build-docs.js publishes them next to the docs hub (CIB-1263). Same origin
 * as the app, so the docs edge function lets the request through on the app's own referer.
 */
export const RELEASES_URL = '/docs/guides/novedades.json';

/**
 * The docs hub pages. App routes, not files: AppRouter renders each one in an iframe behind
 * `ProtectedRoute requiredRoles={DOCS_ROLES}`, so only those roles see the links.
 */
export const DOCS_LINKS = {
  swagger: '/docs/api-collections',
  storybook: '/docs/storybook',
  backend: '/docs/backend',
  guides: '/docs',
} as const;

/** The roles AppRouter lets into /docs. Kept in step with its `requiredRoles`. */
export const DOCS_ROLES: readonly string[] = ['admin', 'superadmin', 'implementador'];

/**
 * Only reads run from the try-it panel. A write from a learning page could change a customer's
 * agent by accident; for those the panel shows the request and sends the user to the screen.
 */
export const TRY_METHODS: ReadonlySet<string> = new Set(['GET']);

/** The longest response body the try-it panel prints before cutting it. */
export const MAX_RESPONSE_CHARS = 20_000;

/** Where the user's progress is kept, per user and account (this browser only). */
export const PROGRESS_STORAGE_PREFIX = 'silia-learning:progress';
export const AUDIENCE_STORAGE_KEY = 'silia-learning:audience';
